module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/partly-cloudy-day-snow-aa9fe108c5c9d0307b012f47d8886d97.svg";